import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChargedActModel} from "../../../../../../../modules/medical/charged-act/api/entity/chargedAct.model";
import {ItemModule} from "../../../../../../../modules/core/component/item/item.module";
import {SummaryModule} from "../../../../../../../modules/core/component/summary/summary.module";
import {SummaryFieldModule} from "../../../../../../../modules/core/component/summary-field/summary-field.module";
import {TablerIconsModule} from "angular-tabler-icons";
import {
    DateSummaryFieldModule
} from "../../../../../../../modules/core/component/date/date-summary-field/date-summary-field.module";
import {
    DocumentSummaryModelFieldModule
} from "../../../../../../../modules/document/common/api/component/document-summary-field/document-summary-field.module";
import {ButtonComponent} from "../../../../core/components/api/button/button.component";
import {
    DocumentDownloadModule
} from "../../../../../../../modules/document/common/api/component/document-download/document-download.module";
import {
    PriceSummaryFieldModule
} from "../../../../../../../modules/common/price/api/component/price-summary-field/price-summary-field.module";
import {SALE_DIRECTION, SALE_STATUS} from "../../../../../../../modules/sale/api/entity/sale.model";
import {ButtonModule} from "../../../../../../../modules/core/component/button/button.module";
import {
    ChargedActSummaryPaidPaymentRequestModule
} from "../../../../../../../modules/medical/charged-act/impl/component/charged-act-summary-paid-payment-request/charged-act-summary-paid-payment-request.module";
import {
    LovValueSummaryFieldModule
} from "../../../../../../../modules/common/lov/lov-value/api/component/lov-value-summary-field/lov-value-summary-field.module";
import {
    PartnerSummaryFieldModule
} from "../../../../../../../modules/partner/common/api/component/partner-summary-field/partner-summary-field.module";
import {PriceLabelModule} from "../../../../../../../modules/common/price/api/component/price-label/price-label.module";
import {
    PaymentRequestSummaryModel
} from "../../../../../../../modules/sale/modules/payment_request/api/entity/paymentRequestSummary.model";
import {ActionButtonModule} from "../../../../../../../modules/core/component/action-button/action-button.module";
import {
    ChargedActSetStatusService
} from "../../../../../../../modules/medical/charged-act/impl/service/chargedActSetStatus.service";
import {
    ChargedActAcceptDialogComponent,
    ChargedActAcceptDialogInput,
    ChargedActAcceptDialogResult
} from "../../../../../../../modules/medical/charged-act/api/component/charged-act-accept-dialog/charged-act-accept-dialog.component";
import {
    SaleInvoiceSaveDialogInput,
    SaleInvoiceSaveDialogPage,
    SaleInvoiceSaveDialogResult
} from "../../../../../../../modules/sale/modules/invoice/impl/page/sale-invoice-save-dialog/sale-invoice-save-dialog.page";
import {
    ChargedActSetStatusPayload
} from "../../../../../../../modules/medical/charged-act/impl/service/payload/chargedActSetStatus.payload";
import {
    PurchaseOrderSendByEmailComponent,
    PurchaseOrderSendByEmailInput
} from "../../../../../../../modules/sale/modules/purchase_order/api/component/purchase-order-send-by-email/purchase-order-send-by-email.component";
import {DialogController} from "../../../../../../../modules/common/dialog/dialogController";
import {BaseView} from "../../../../../../../modules/core/view/base.view";
import {
    ProductSummaryFieldModule
} from "../../../../../../../modules/product/api/component/product-summary-field/product-summary-field.module";
import {
    DocumentSignDialogComponent,
    DocumentSignDialogInput,
    DocumentSignDialogOutput
} from "../../../../../../../modules/document/signature/api/component/document-sign-dialog/document-sign-dialog.component";
import {
    ChargedActFindOneByIdService
} from "../../../../../../../modules/medical/charged-act/impl/service/chargedActFindOneById.service";
import {
    SaleInvoiceSaveDialogModule
} from "../../../../../../../modules/sale/modules/invoice/impl/page/sale-invoice-save-dialog/sale-invoice-save-dialog.module";
import {
    ChargedActAcceptDialogModule
} from "../../../../../../../modules/medical/charged-act/api/component/charged-act-accept-dialog/charged-act-accept-dialog.module";
import {
    ChargedActDeleteService
} from "../../../../../../../modules/medical/charged-act/impl/service/chargedActDelete.service";
import {
    PaymentRequestMovementCreateDialogComponent,
    PaymentRequestMovementCreateDialogInput
} from "../../../../../../../modules/sale/modules/payment_request/movement/api/component/payment-request-movement-create-dialog/payment-request-movement-create-dialog.component";
import {
    PaymentRequestMovementCreateDialogModule
} from "../../../../../../../modules/sale/modules/payment_request/movement/api/component/payment-request-movement-create-dialog/payment-request-movement-create-dialog.module";
import {
    ChargedActRepository
} from "../../../../../../../modules/medical/charged-act/impl/service/ngrx/chargedAct.repository";
import {
    SaleInvoiceSendByEmailDialogInput,
    SaleInvoiceSendByEmailPage
} from "../../../../../../../modules/sale/modules/invoice/impl/page/sale-invoice-send-by-email/sale-invoice-send-by-email.page";
import {
    SaleInvoiceSendByEmailPageModule
} from "../../../../../../../modules/sale/modules/invoice/impl/page/sale-invoice-send-by-email/sale-invoice-send-by-email.module";
import {DateLabelModule} from "../../../../../../../modules/core/component/date/date-label/date-label.module";

@Component({
    selector: 'app-luna-consultation-charged-act-item',
    standalone: true,
    imports: [CommonModule, ItemModule, SummaryModule, SummaryFieldModule, TablerIconsModule, DateSummaryFieldModule, DocumentSummaryModelFieldModule, ButtonComponent, DocumentDownloadModule, PriceSummaryFieldModule, ButtonModule, ChargedActSummaryPaidPaymentRequestModule, LovValueSummaryFieldModule, PartnerSummaryFieldModule, PriceLabelModule, ActionButtonModule, ProductSummaryFieldModule, SaleInvoiceSaveDialogModule, ChargedActAcceptDialogModule, PaymentRequestMovementCreateDialogModule, SaleInvoiceSendByEmailPageModule, DateLabelModule],
    templateUrl: './consultation-charged-act-item.component.html',
    providers: [
        ChargedActSetStatusService,
        ChargedActFindOneByIdService,
        ChargedActDeleteService,
    ]
})
export class ConsultationChargedActItemComponent extends BaseView implements OnChanges {
    @Input() entity: ChargedActModel;
    @Input() hideButtons = false;
    @Input() displayDate = true;

    protected readonly SALE_STATUS = SALE_STATUS;

    notPaidPaymentRequests: PaymentRequestSummaryModel[] = [];
    paidPaymentRequests: PaymentRequestSummaryModel[] = [];

    constructor(public chargedActSetStatusService: ChargedActSetStatusService,
                private dialogController: DialogController,
                private findOneService: ChargedActFindOneByIdService,
                public deleteService: ChargedActDeleteService,
                private chargedActRepository: ChargedActRepository) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['entity']) {
            this.notPaidPaymentRequests = [];
            this.paidPaymentRequests = [];
            if (this.entity) {
                this.notPaidPaymentRequests = this.entity.sale.paymentRequests.filter(value => value.isPaid() === false);
                this.paidPaymentRequests = this.entity.sale.paymentRequests.filter(value => value.isPaid() === true);
            }
        }
    }

    statusChanged(value: ChargedActModel) {
        console.log(['status changed method', value]);
        this.entity = value;
        this.toastControl.presentConfirmation('L\'acte facturé a été mis à jour.');
    }

    accept() {
        const input: ChargedActAcceptDialogInput = {
            id: this.entity.id
        };
        this.dialogController.open(ChargedActAcceptDialogComponent, input, {
            title: 'Accepter le devis'
        }).afterClosed().toPromise().then((result: ChargedActAcceptDialogResult) => {
            console.log(['accept dialog closed', result]);
            if (result) {
                this.entity = result.chargedAct;
                this.statusChanged(result.chargedAct);
            }
        });
    }

    sign() {
        const input: DocumentSignDialogInput = {documentId: this.entity.sale.purchaseOrders[0].document.id};
        this.dialogController.open(DocumentSignDialogComponent,
            input, {
            width: '95%'
            }).afterClosed()
            .toPromise()
            .then((result: DocumentSignDialogOutput) => {
                if (result.signed) {
                    this.findOneService.loadEntity(this.entity.id)
                        .then(entity => this.entity = entity)
                        .catch((e) => this.toastControl.presentError(e, 'Actualisation du devis impossible'));
                }
            });
    }

    newInvoice() {
        const input: SaleInvoiceSaveDialogInput = {
            saleId: this.entity.sale.id,
            hideManualDocumentUpload: true
        };
        this.dialogController.open(SaleInvoiceSaveDialogPage,
            input, {
                title: 'Nouvelle facture'
            }).afterClosed()
            .toPromise()
            .then((result: SaleInvoiceSaveDialogResult) => {
                if (result) {
                    this.entity.sale.invoices.push(result.entity.summary);
                }
            });
    }

    buildRefusedPayload = (): ChargedActSetStatusPayload => {
        return {
            statusValue: SALE_STATUS.SALE_STATUS_REFUSED,
            id: this.entity.id
        };
    }

    sendPurchaseOrderByEmail() {
        const input: PurchaseOrderSendByEmailInput = {
            purchaseOrderSummary: this.entity.sale.purchaseOrders[0],
            toEmail: this.entity.sale.partner.email
        };
        this.dialogController.open(PurchaseOrderSendByEmailComponent,
            input, {
                title: 'Envoyer le devis par e-mail',
                width: '95%'
            });
    }

    sendInvoiceByEmail() {
        const input: SaleInvoiceSendByEmailDialogInput = {
            id: this.entity.sale.invoices[0].id,
        };
        this.dialogController.open(SaleInvoiceSendByEmailPage,
            input, {
                title: 'Envoyer le devis par e-mail',
                width: '95%'
            });
    }

    pay(paymentRequest: PaymentRequestSummaryModel) {
        const input: PaymentRequestMovementCreateDialogInput = {
            paymentRequestId: paymentRequest.id,
            labelValue: 'CONSULTATION',
            direction: this.entity.sale.direction.value as SALE_DIRECTION,
            partnerId: this.entity.sale.partner.id,
        };
        this.dialogController.open(PaymentRequestMovementCreateDialogComponent,
            input, {
                title: 'Ajouter un paiement',
                width: '95%'
            }).afterClosed().toPromise().then(() => {
            this.chargedActRepository.updated(this.entity);
        });
    }
}
